import { Link } from 'react-router-dom';

const footerLinks = {
  探索: [
    { label: '时尚精品', to: '/categories?tab=fashion' },
    { label: '美妆护肤', to: '/categories?tab=beauty' },
    { label: '家居生活', to: '/categories?tab=home' },
    { label: '生活好物', to: '/categories?tab=lifestyle' },
  ],
  品牌: [
    { label: '关于我们', to: '/about' },
    { label: '品牌故事', to: '/about#story' },
    { label: '品牌信誉', to: '/about#reputation' },
    { label: '联系我们', to: '/about#contact' },
  ],
  内容: [
    { label: '精选文章', to: '/articles' },
    { label: '品牌推荐', to: '/categories' },
    { label: '好物种草', to: '/articles' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-10">
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="font-heading text-xl font-semibold tracking-wide text-background-50">
              亚洲精品
            </Link>
            <p className="mt-4 text-sm text-foreground-100 leading-relaxed max-w-xs">
              甄选日韩、东南亚及华系顶尖品牌，为您呈现最具品质与设计感的亚洲精品生活。
            </p>
          </div>

          {Object.entries(footerLinks).map(([group, links]) => (
            <div key={group}>
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">{group}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-100 hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-200">
            &copy; 2026 亚洲精品生活馆. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-700 transition-colors text-background-200 text-sm cursor-pointer" aria-label="微信">
              <i className="ri-wechat-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-700 transition-colors text-background-200 text-sm cursor-pointer" aria-label="微博">
              <i className="ri-weibo-line"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-foreground-700 transition-colors text-background-200 text-sm cursor-pointer" aria-label="小红书">
              <i className="ri-reddit-line"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}